import { authRoles } from 'app/auth';
import ReviewTable from 'app/admin/review/table/ReviewTable';
import ReviewEditForm from 'app/admin/review/editform/ReviewEditForm';

export default [
	{
		path: '/kerdes-velemeny/edit/:id',
		component: ReviewEditForm,
		auth: authRoles.admin
	},
	{
		path: '/kerdes-velemeny/:sessionNameParam?',
		component: ReviewTable,
		auth: authRoles.admin
	}
];